import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiltroTablaComponent } from './filtro-tabla.component';
import { MaterialModule } from '../material.module';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [FiltroTablaComponent],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    FlexLayoutModule,
    NgSelectModule,
  ],
  exports: [FiltroTablaComponent],
})
export class FiltroTablaModule {}
